import { memo } from 'react';

import IndexBrandAd from '../homeComponents/components/IndexBrandAd';

import Banner from './components/Banner';
import FilterAndList from './components/FilterAndList';
import NewestBrandInfo from './components/NewestBrandInfo';

const Index = (props) => {
  const { isLgScreen, indexAd, brandIndexInformationData, brandCatalogList, brandData, leftHeight, resourceData } =
    props;
  return (
    <div className={'bg-[#F5F8FA]'}>
      <div className={'mb-[30px]'}>
        <Banner></Banner>
      </div>
      <IndexBrandAd
        isLgScreen={isLgScreen}
        data={indexAd}
        showChildren={true}
        height={304}
        bottom={40}
        paddingTopValue={0}
        noBorder={true}
      >
        <div className={'text-[#000000] text-[28px] font-bold text-center pt-[26px] pb-[13px]'}>
          3000+国内外知名品牌
        </div>
      </IndexBrandAd>
      <NewestBrandInfo
        isLgScreen={isLgScreen}
        brandIndexInformationData={brandIndexInformationData}
        resourceData={resourceData}
      ></NewestBrandInfo>
      <FilterAndList
        isLgScreen={isLgScreen}
        brandCatalogList={brandCatalogList}
        brandData={brandData}
        leftHeight={leftHeight}
        resourceData={resourceData}
      ></FilterAndList>
    </div>
  );
};

export default memo(Index);
